import e from "../../_virtual/_plugin-vue_export-helper.js";
import { createElementBlock as t, openBlock as n } from "vue";
//#region src/icons-legacy/euro/euro-sign-24.vue
var r = {}, i = {
	d: "M13 3h5.5a.5.5 0 0 1 0 1H13a4.5 4.5 0 0 0-4.5 4.5V10h9a.5.5 0 0 1 0 1h-9v2h7a.5.5 0 0 1 0 1h-7v1.5A4.5 4.5 0 0 0 13 20h5.5a.5.5 0 0 1 0 1H13a5.5 5.5 0 0 1-5.5-5.5V14h-4a.5.5 0 1 1 0-1h4v-2h-3a.5.5 0 1 1 0-1h3V8.5A5.5 5.5 0 0 1 13 3Z",
	fill: "currentColor"
};
function a(e, r) {
	return n(), t("path", i);
}
var o = /*#__PURE__*/ e(r, [["render", a]]);
//#endregion
export { o as default };
